import React from 'react';
import { Box } from '@mui/material';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import { useAppDispatch } from 'app/hooks';
import { ideasActions } from 'features/feedback/store/ideas.slice';

const VoteButton: React.FC<{ id: number; count: number; voted: boolean }> = ({ id, count, voted }) => {
  const dispatch = useAppDispatch();
  const toggle = () => dispatch(ideasActions.voteToggle(id));
  return (
    <Box
      role="button"
      aria-label="Голосувати"
      aria-pressed={voted}
      tabIndex={0}
      onClick={toggle}
      onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); } }}
      sx={{
        width: 58, flex: '0 0 auto', cursor: 'pointer', userSelect: 'none',
        display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.25,
        py: 1, borderRadius: '10px',
        border: `1px solid ${voted ? '#3B2C93' : '#BBBFC7'}`,
        background: voted ? 'rgba(59,44,147,.06)' : '#fff',
        color: voted ? '#3B2C93' : '#4a4f57',
      }}
    >
      <ExpandLessIcon sx={{ fontSize: 20 }} />
      <Box sx={{ fontSize: 15, fontWeight: 700 }}>{count}</Box>
    </Box>
  );
};

export default VoteButton;
